import React, { useEffect } from "react";
import { Box } from "@mui/material";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ServicesHero from "../components/Services/ServicesHero";
import ServiceDetail from "../components/Services/ServiceDetail";
import ServicesCta from "../components/Services/ServicesCta";
import servicesData from "../data/servicesData";
import { layout } from "../theme/tokens";

const Services = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Handle hash scroll after mount
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const timer = setTimeout(() => {
        const el = document.getElementById(hash.replace("#", ""));
        if (el) {
          const offset = 90;
          const top = el.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top, behavior: "smooth" });
        }
      }, 400);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <Box sx={{ overflowX: "hidden", backgroundColor: "#F5F7FA" }}>
      <Navbar />
      <ServicesHero />
      <Box
        component="section"
        sx={{ pt: "30px", pb: "70px", px: { xs: "20px", md: "28px" } }}
      >
        <Box
          sx={{
            maxWidth: layout.maxWidth,
            mx: "auto",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          {servicesData.map((service, index) => (
            <ServiceDetail key={service.id} service={service} index={index} />
          ))}
        </Box>
      </Box>
      <ServicesCta />
      <Footer />
    </Box>
  );
};

export default Services;
